import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/TreeView/TreeView.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/tree-view/react/latest'} mdxType="DeprecationBanner" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {TreeView} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`File tree navigation without directory links`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{maxWidth: 400}}>
  <nav aria-label="Files">
    <TreeView aria-label="Files">
      <TreeView.Item id="src">
        <TreeView.LeadingVisual>
          <TreeView.DirectoryIcon />
        </TreeView.LeadingVisual>
        src
        <TreeView.SubTree>
          <TreeView.Item id="src/Avatar.tsx" onSelect={() => console.log('src/Avatar.tsx')}>
            <TreeView.LeadingVisual>
              <FileIcon />
            </TreeView.LeadingVisual>
            Avatar.tsx
            <TreeView.TrailingVisual>
              <Octicon icon={DiffAddedIcon} color="success.fg" aria-label="Added" />
            </TreeView.TrailingVisual>
          </TreeView.Item>
          <TreeView.Item id="src/Button.tsx" current>
            <TreeView.LeadingVisual>
              <FileIcon />
            </TreeView.LeadingVisual>
            Button.tsx
            <TreeView.TrailingVisual>
              <Octicon icon={DiffModifiedIcon} color="attention.fg" aria-label="Modified" />
            </TreeView.TrailingVisual>
          </TreeView.Item>
        </TreeView.SubTree>
      </TreeView.Item>
      <TreeView.Item id="package.json">
        <TreeView.LeadingVisual>
          <FileIcon />
        </TreeView.LeadingVisual>
        package.json
        <TreeView.TrailingVisual>
          <Octicon icon={DiffModifiedIcon} color="attention.fg" aria-label="Modified" />
        </TreeView.TrailingVisual>
      </TreeView.Item>
    </TreeView>
  </nav>
</Box>
`}</code></pre>
    <h3>{`File tree navigation with directory links`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{maxWidth: 400}}>
  <nav aria-label="Files">
    <TreeView aria-label="Files">
      <TreeView.Item id="src">
        <TreeView.LeadingVisual>
          <TreeView.DirectoryIcon />
        </TreeView.LeadingVisual>
        src
        <TreeView.SubTree>
          <TreeView.Item id="src/Avatar.tsx">
            <TreeView.LeadingVisual>
              <FileIcon />
            </TreeView.LeadingVisual>
            Avatar.tsx
          </TreeView.Item>
          <TreeView.Item id="src/Button" current>
            <TreeView.LeadingVisual>
              <TreeView.DirectoryIcon />
            </TreeView.LeadingVisual>
            Button
            <TreeView.SubTree>
              <TreeView.Item id="src/Button/Button.tsx">
                <TreeView.LeadingVisual>
                  <FileIcon />
                </TreeView.LeadingVisual>
                Button.tsx
              </TreeView.Item>
              <TreeView.Item id="src/Button/Button.test.tsx">
                <TreeView.LeadingVisual>
                  <FileIcon />
                </TreeView.LeadingVisual>
                Button.test.tsx
              </TreeView.Item>
            </TreeView.SubTree>
          </TreeView.Item>
        </TreeView.SubTree>
      </TreeView.Item>
      <TreeView.Item id="package.json">
        <TreeView.LeadingVisual>
          <FileIcon />
        </TreeView.LeadingVisual>
        package.json
      </TreeView.Item>
    </TreeView>
  </nav>
</Box>
`}</code></pre>
    <h3>{`With React Router`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {Link, useMatch, useResolvedPath, navigate} from 'react-router-dom'
import {TreeView} from '@primer/react'

function TreeLinkItem({id, to, children}) {
  const resolved = useResolvedPath(to)
  const isCurrent = useMatch({path: resolved.pathname, end: true})
  return (
    <TreeList.Item
      id={id}
      aria-current={isCurrent ? 'page' : undefined}
      current={isCurrent}
      onSelect={() => navigate(to)}
    >
      {children}
    </TreeList.Item>
  )
}

function App() {
  return (
    <nav aria-label="Files">
      <TreeView aria-label="Files">
        <TreeLinkItem id="src/Avatar.tsx" to="/src/Avatar.tsx">
          Avatar.tsx
        </TreeLinkItem>
        <TreeLinkItem id="src/Button.tsx" to="/src/Button.tsx">
          Button.tsx
        </TreeLinkItem>
      </TreeView>
    </nav>
  )
}
`}</code></pre>
    <h3>{`With Next.js`}</h3>
    <p>{`Please note that we advise against using this pattern for website navigation because it's not the expected semantic structure for a navigation component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {useRouter} from 'next/router'
import Link from 'next/link'
import {TreeView} from '@primer/react/drafts'

function TreeLinkItem({id, href, children}) {
  const router = useRouter()
  const isCurrent = typeof href === 'string' ? router.asPath === href : router.pathname === href.pathname
  return (
    <Link href={href} passHref>
      <TreeView.Item id={id} aria-current={isCurrent ? 'page' : false} current={isCurrent}>
        {children}
      </TreeView.Item>
    </Link>
  )
}

function App() {
  return (
    <nav aria-label="Files">
      <TreeView aria-label="Files">
        <TreeLinkItem id="src/Avatar.tsx" href="/src/Avatar.tsx">
          Avatar.tsx
        </TreeLinkItem>
        <TreeLinkItem
          id="src/Button.tsx"
          // You can also pass a URL object
          // https://nextjs.org/docs/api-reference/next/link#with-url-object
          href={{
            pathname: '/src/[component].[filetype]',
            query: {component: 'Button', filetype: 'tsx'},
          }}
        >
          Button.tsx
        </TreeLinkItem>
      </TreeView>
    </nav>
  )
}
`}</code></pre>
    <h3>{`With controlled expanded state`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`function ControlledTreeView() {
  const [expanded, setExpanded] = React.useState(false)

  return (
    <Box sx={{display: 'grid', gap: 2, maxWidth: 400}}>
      <Button onClick={() => setExpanded(!expanded)}>{expanded ? 'Collapse' : 'Expand'}</Button>
      <nav aria-label="Files">
        <TreeView aria-label="Files">
          <TreeView.Item id="src" expanded={expanded} onExpandedChange={setExpanded}>
            src
            <TreeView.SubTree>
              <TreeView.Item id="src/Avatar.tsx">Avatar.tsx</TreeView.Item>
              <TreeView.Item id="src/Button.tsx" current>
                Button.tsx
              </TreeView.Item>
            </TreeView.SubTree>
          </TreeView.Item>
        </TreeView>
      </nav>
    </Box>
  )
}

render(<ControlledTreeView />)
`}</code></pre>
    <h3>{`With stateful visuals`}</h3>
    <p>{`To render stateful visuals, pass a render function to `}<inlineCode parentName="p">{`TreeView.LeadingVisual`}</inlineCode>{` or `}<inlineCode parentName="p">{`TreeView.TrailingVisual`}</inlineCode>{`. The function will be called with the `}<inlineCode parentName="p">{`expanded`}</inlineCode>{` state of the item.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{maxWidth: 400}}>
  <nav aria-label="Files">
    <TreeView aria-label="Files">
      <TreeView.Item id="src">
        <TreeView.LeadingVisual>
          {({isExpanded}) => (isExpanded ? <FileDirectoryOpenFillIcon /> : <FileDirectoryFillIcon />)}
        </TreeView.LeadingVisual>
        src
        <TreeView.SubTree>
          <TreeView.Item id="src/Avatar.tsx">Avatar.tsx</TreeView.Item>
          <TreeView.Item id="src/Button.tsx" current>
            Button.tsx
          </TreeView.Item>
        </TreeView.SubTree>
      </TreeView.Item>
    </TreeView>
  </nav>
</Box>
`}</code></pre>
    <p>{`Since stateful directory icons are a common use case for TreeView, we provide a `}<inlineCode parentName="p">{`TreeView.DirectoryIcon`}</inlineCode>{` component for convenience. The previous example can be rewritten as:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{maxWidth: 400}}>
  <nav aria-label="Files">
    <TreeView aria-label="Files">
      <TreeView.Item id="src">
        <TreeView.LeadingVisual>
          <TreeView.DirectoryIcon />
        </TreeView.LeadingVisual>
        src
        <TreeView.SubTree>
          <TreeView.Item id="src/Avatar.tsx">Avatar.tsx</TreeView.Item>
          <TreeView.Item id="src/Button.tsx" current>
            Button.tsx
          </TreeView.Item>
        </TreeView.SubTree>
      </TreeView.Item>
    </TreeView>
  </nav>
</Box>
`}</code></pre>
    <h3>{`With asynchronously loaded items`}</h3>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://primer.style/react/storybook?path=/story/components-treeview--async-success"
      }}>{`Storybook`}</a>{` for examples with asynchronously loaded items.`}</p>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      visualRegressionCoverage: true,
      noAxeViolations: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: true,
      a11yReviewed: true,
      noPerfRegression: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      